import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const Stocks = () => {
  const [value, setValue] = useState("138.1.MSTATS_ALL_MS");
  const [activeData, setActiveData] = useState([]);
  const [gainersData, setGainersData] = useState([]);
  const [losersData, setLosersData] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [state, setState] = useState("Most Active Stocks");

  useEffect(() => {
    async function fetchData() {
      // console.log("---------------- fetchData() called ----------------");
      try {
        const url = new URL(
          `https://www.msn.com/en-in/money/markets/marketmoversajax/${value}?ver=20230109_33393850`
        );
        const response = await fetch(url);
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        const json = await response.json();
        setActiveData(json.A);
        setGainersData(json.G);
        setLosersData(json.L);
        setTableData(json.A);
      } catch (error) {
        console.error("Network Error", error);
      }
    }
    try {
      fetchData();
      setState("Most Active Stocks");
    } catch (error) {
      console.log("Network Error");
    }
  }, [value]);

  const handleSelectChange = (event) => {
    const newValue = event.target.value;
    setValue(newValue);
  };

  useEffect(() => {
    if (state === "Most Active Stocks") {
      setTableData(activeData);
    } else if (state === "Top Gainers") {
      setTableData(gainersData);
    } else if (state === "Top Losers") {
      setTableData(losersData);
    }
    // console.log("tabledata -- >", tableData);
  }, [state, activeData, gainersData, losersData]);

  const onClickBtn = (stateData) => {
    setState(stateData);
  };

  console.log(tableData.length);
  return (
    <>
      <div className="chart_container ml1">
        <div className="dd_container">
          <select id="moverslist" onChange={handleSelectChange}>
            <option className="dropdown" value="138.1.MSTATS_ALL_MS">
              NSE
            </option>
            <option className="dropdown" value="139.1.MSTATS_ALL_MS">
              BSE
            </option>
            <option className="dropdown" value="126.1.MSTATS_ALL_MS">
              US Composite
            </option>
            <option className="dropdown" value="127.1.MSTATS_ALL_MJ">
              Toronto
            </option>
            <option className="dropdown" value="56.1.MSTATS_ALL_MS">
              Brazil
            </option>
            <option className="dropdown" value="151.1.MSTATS_ALL_MS">
              London
            </option>
            <option className="dropdown" value="213.1.MSTATS_DAX30">
              DAX 30
            </option>
            <option className="dropdown" value="160.1.MSTATS_ALL_MS">
              Paris
            </option>
            <option className="dropdown" value="133.1.MSTATS_ALL_MS">
              Tokyo
            </option>
            <option className="dropdown" value="136.1.MSTATS_ALL_MS">
              Shanghai
            </option>
          </select>
        </div>
        <div className="chart_headers chart_title_container">
          <button onClick={() => onClickBtn("Most Active Stocks")}>
            <h6
              className={`chart_title ${state === "Most Active Stocks" ? "active" : ""
                }`}
            >
              Most Active Stocks
            </h6>
          </button>
          <button onClick={() => onClickBtn("Top Gainers")}>
            <h6
              className={`chart_title ${state === "Top Gainers" ? "active" : ""
                }`}
            >
              Top Gainers
            </h6>
          </button>
          <button onClick={() => onClickBtn("Top Losers")}>
            <h6
              className={`chart_title ${state === "Top Losers" ? "active" : ""
                }`}
            >
              Top Losers
            </h6>
          </button>
        </div>
        <div>
          <div className="graph_container">
            <table className="table table_head">
              <thead className="table_head">
                <tr>
                  <th scope="col">Company</th>
                  <th scope="col">
                    Price<span className="muted"></span>
                  </th>
                  <th scope="col">
                    Change<span className="muted"></span>
                  </th>
                </tr>
              </thead>
              <tbody>
                {tableData.length === 0 ? "No data Available Now" : ""}
                {tableData.map((data) => {
                  const x_instrumentId = data.UriLink.substring(
                    data.UriLink.length - 6
                  );
                  // console.log(x_instrumentId);
                  return (
                    <tr key={data.tkr}>
                      <td>
                        <Link
                          className="complink"
                          to={`company/${data.name} ${x_instrumentId}`}
                        >
                          {data.name}
                        </Link>
                      </td>
                      <td
                        className="Number"
                        value={data.price}
                        style={{ color: data.change < 0 ? "red" : "#04b03e" }}
                      >
                        {data.price}
                      </td>
                      <td
                        className="Number"
                        value={data.change}
                        style={{ color: data.change < 0 ? "red" : "#04b03e" }}
                      >
                        {data.change} ({data.changePercent})
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
};

export default Stocks;
